import { createActionGroup, props } from "@ngrx/store";
import { Unspsc } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataUnspscsActions = createActionGroup({
    source: "Data / Unspscs",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ unspscs: Unspsc[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
